import { InjectionToken } from '@angular/core';
import { IAlertConfig, IConfirmConfig, ITooltipConfig } from '../model/dialog.interface';

export const DIALOG_CONFIG = new InjectionToken<IAlertConfig | IConfirmConfig | ITooltipConfig>('DIALOG_CONFIG');
